import * as React from 'react';
import { _t } from '@hip/translations';
export const ChevronUpIcon = ({ altText }) => {
    const alt = altText || _t('icons.chevron_up');
    return (React.createElement("svg", { role: "img", "aria-label": alt, width: "16px", height: "16px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", null, alt),
        React.createElement("path", { d: "M20.533 18L22 16.612 12 6 2 16.612 3.467 18 12 8.945z", fillRule: "evenodd" })));
};
